/**
 * Voice feature query-key factory — mirrors `features/campaigns/query-keys.ts`.
 */
export const voiceKeys = {
    settings: () => ['voice', 'settings'] as const,
    numbers: () => ['voice', 'numbers'] as const,
    /** Under the `numbers()` prefix so config saves invalidate it too. */
    myNumbers: () => ['voice', 'numbers', 'mine'] as const,
    presence: () => ['voice', 'presence'] as const,
    numberConfig: (channelIdentityId: string) =>
        ['voice', 'numbers', channelIdentityId, 'config'] as const,
    greetingPlayback: (storageKey: string) => ['voice', 'greeting-playback', storageKey] as const,
    calls: {
        all: ['voice', 'calls'] as const,
        /** Outside `lists()`: the numbers do not change with a Refresh of the rows. */
        businessNumbers: () => ['voice', 'calls', 'business-numbers'] as const,
        /** Prefix of every `list(...)` — the Call History page's Refresh. */
        lists: () => ['voice', 'calls', 'list'] as const,
        list: (params?: unknown) => ['voice', 'calls', 'list', params ?? null] as const,
        detail: (id: string) => ['voice', 'calls', id] as const,
        /** Prefix of every `analytics(...)` — the stat cards above the list. */
        analyticsAll: () => ['voice', 'calls', 'analytics'] as const,
        analytics: (params?: unknown) => ['voice', 'calls', 'analytics', params ?? null] as const,
        /** Widget History tab — infinite pages, keyed by caller-ID filter. */
        history: (channelIdentityId: string | null) =>
            ['voice', 'calls', 'history', channelIdentityId] as const,
        /** Widget per-number detail timeline — infinite pages, keyed by counterpart. */
        counterpart: (counterpartNumber: string) =>
            ['voice', 'calls', 'history', 'counterpart', counterpartNumber] as const,
    },
    recordings: {
        all: ['voice', 'recordings'] as const,
        list: (params?: unknown) => ['voice', 'recordings', 'list', params ?? null] as const,
        url: (id: string) => ['voice', 'recordings', id, 'url'] as const,
    },
    blockedNumbers: {
        all: ['voice', 'blocked-numbers'] as const,
        list: (params?: unknown) => ['voice', 'blocked-numbers', 'list', params ?? null] as const,
    },
} as const;
